export { ComponentWidgetRenderer } from './ComponentWidgetRenderer'
export { ParcelLabWidgetRenderer } from './ParcelLabWidgetRenderer/ParcelLabWidgetRenderer'
export { WidgetRenderer } from './WidgetRenderer'
